import Component from './direct_message_message_table.vue'
export default Component
